import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { CreateBrandExcel } from 'app/dtos/brand/create-brand-excel';

@Injectable({
  providedIn: 'root'
})
export class BrandService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllBrand(page,size,search){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Brand,
      queryString:`page=${page}&size=${size}&search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async getBrands(){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Brand,
      action:"GetBrands"
    });
    return await firstValueFrom(observable);
  }


  async updateBrand(id,name){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.Brand
    },{
      id:id,
      name:name
    });
    return await firstValueFrom(observable);
  }

  async createBrand(name){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Brand
    },{
      name:name
    });
    return await firstValueFrom(observable);
  }

  async uploadBrandExcel(createBrandExcels:CreateBrandExcel[]){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Brand,
      action:"UploadBrandExcel"
    },createBrandExcels);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();
  
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
